<div class="file-exports-ui-list-item">
  <div class="title-container" [class.is-generating]="status === 'init'">
    <capra-icon class="title-icon {{iconName}}" [icon]="iconName"></capra-icon>
    <p [title]="title">
      <span *ngIf="status === 'init'">Generating </span>
      {{ title }}
    </p>
  </div>
  <div class="button-container">
    <div class="download-retry-buttons">
      <capra-button
        *ngIf="status === 'success'"
        variant="secondary"
        text="Download"
        size="small"
        color="neutral"
        data-test="download-individual-download-button"
        (clicked)="onDownloadClick(id)"
      ></capra-button>
      <capra-button
        *ngIf="status === 'error'"
        variant="secondary"
        text="Retry Export"
        color="neutral"
        size="small"
        data-test="retry-individual-download-button"
        (clicked)="onRetryExportClick(id)"
      ></capra-button>
    </div>
    <capra-icon-button
      class="delete-button"
      *ngIf="status !== 'init'"
      icon="icon-close"
      size="medium"
      data-test="close-individual-download-button"
      (clicked)="onDeleteClick(id)"
    ></capra-icon-button>
  </div>
</div>